import React, { Component } from 'react';
import { connect } from 'react-redux';
import lang from "./../../../../languages/en";
import { Checkbox } from 'antd';
import { onChange, onChangeItem } from "./../../../../actions/addOrder"; 
import './toolTipwarringProhibited.css';

class ToolTipWarringProhibited extends Component {

    constructor(props) {
        super(props)
        this.wrapperRef = React.createRef()
        this.state = {
            checked: this.props.itemData.HasApproveKeyWordBL
        }
        
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick)
    }
    
    componentWillUnmount() {
        // important
        document.removeEventListener('click', this.handleClick)
    }
    
    handleClick = (event) => {
        const { target } = event
        if (!this.wrapperRef.current.contains(target) && !this.props.clickInsideItemName) {
            this.props.onChange({ value: '', column: 'tooltip' })
            this.props.onChange({ value: '', column: 'message' })
            this.props.onChangeClickInSite("clickInsideToolTipWarring", false)
        } else {
            this.props.onChangeClickInSite("clickInsideToolTipWarring", true)
           
        }
    }

    handleChangeIgnoreApprove = (e) => {
        let checked = e.target.checked;
        let { itemData, itemsEditOrder, itemsAddOrder } = this.props;
        let items;
        if (this.props.pageType === 'editOrder') {
            items = itemsEditOrder
        } else {
            items = itemsAddOrder
        }
        let hasItemData = false;
        for (let i = 0; i < items.length; i++) {
            if (items[i].key === itemData.key) {
                hasItemData = true;
                items[i].HasApproveKeyWordBL = checked;
            }
        }
        if (!hasItemData) {
            itemData.HasApproveKeyWordBL = checked;
            items.push(itemData);
        }
        this.setState({
            checked
        })
        
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
        this.props.onChangeItem(items);
    }

    render() {
        return (
            <div ref={this.wrapperRef}>
                <div>
                <div className="tt-content">
                    <span>{`${lang.content_tooltip_warring_prohibited} "${this.props.keywordContains.join(", ")}". ${lang.content_tooltip_warning_prohibited_2}`} </span>
                </div>
                <div className="tt-btn">
                    <Checkbox onChange={ this.handleChangeIgnoreApprove} checked={this.state.checked}/> {lang.btn_ignore_approve_prohibited}
                </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        itemsEditOrder: state.editOrder.items,
        itemsAddOrder: state.addOrder.items,
    };
}

function mapDispatchToProps(dispatch) {
    return {
       
        onChangeItem: payload => {
            dispatch(onChangeItem(payload))
        },
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ToolTipWarringProhibited);


// WEBPACK FOOTER //
// ./src/containers/orders/components/items/ToolTipWarringProhibited.js